import { ReactComponent as Info } from "../../Assets/icon/Info-ref.svg";

const InlineErrorMessage = ({ message, color = "var(--Red-Normal, #F04438)" }) => {
  if (!message) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        marginTop: "8px",
        marginBottom: "8px",
      }}
    >
      <Info
        style={{
          minWidth: "16px",
          marginTop: "2px",
          color,
        }}
      />
      <p
        style={{
          color,
          fontFamily: "Urbanist",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "20px",
          margin: 0,
        }}
      >
        {message}
      </p>
    </div>
  );
};

export default InlineErrorMessage;
